import { colorsPrimitive as colors } from "./colorsPrimitive";

export const colorsText = {
	text_primary: colors.primary.grayLight[900],
	text_primary_dark: colors.primary.grayDark[50],
	text_primary_onBrand: colors.primary.base["white"],
	text_primary_onBrand_dark: colors.primary.grayDark[50],

	text_secondary: colors.primary.grayLight[700],
	text_secondary_dark: colors.primary.grayDark[300],
	text_secondary_hover: colors.primary.grayLight[800],
	text_secondary_hover_dark: colors.primary.grayDark[200],
	text_secondary_onBrand: colors.primary.brand[200],
	text_secondary_onBrand_dark: colors.primary.grayDark[300],

	text_tertiary: colors.primary.grayLight[600],
	text_tertiary_dark: colors.primary.grayDark[400],
	text_tertiary_hover: colors.primary.grayLight[700],
	text_tertiary_hover_dark: colors.primary.grayDark[300],
	text_tertiary_onBrand: colors.primary.brand[200],
	text_tertiary_onBrand_dark: colors.primary.grayDark[400],

	text_quaternary: colors.primary.grayLight[500],
	text_quaternary_dark: colors.primary.grayDark[400],
	text_quaternary_onBrand: colors.primary.brand[300],
	text_quaternary_onBrand_dark: colors.primary.grayDark[400],

	text_white: colors.primary.base["white"],
	text_disabled: colors.primary.grayLight[500],
	text_disabled_dark: colors.primary.grayDark[500],
	text_placeholder: colors.primary.grayDark[500],
	text_placeholder_dark: colors.primary.grayDark[400],
	text_placeholder_subtle: colors.primary.grayDark[300],
	text_placeholder_subtle_dark: colors.primary.grayDark[500],

	text_brand_primary: colors.primary.brand[900],
	text_brand_primary_dark: colors.primary.grayDark[50],
	text_brand_secondary: colors.primary.brand[700],
	text_brand_secondary_dark: colors.primary.grayDark[300],
	text_brand_secondary_subtle: colors.primary.brand[800],
	text_brand_secondary_subtle_dark: colors.primary.grayDark[300],
	text_brand_tertiary: colors.primary.brand[600],
	text_brand_tertiary_dark: colors.primary.grayDark[400],
	text_brand_tertiary_alt: colors.primary.brand[600],
	text_brand_tertiary_alt_dark: colors.primary.grayDark[50],

	text_error_primary: colors.primary.error[600],
	text_error_primary_dark: colors.primary.error[400],
	text_warning_primary: colors.primary.warning[600],
	text_warning_primary_dark: colors.primary.warning[400],
	text_success_primary: colors.primary.success[600],
	text_success_primary_dark: colors.primary.success[400],
};
